import type { ConsumerApiClient } from '../client';

export interface MediaContent {
  id: string;
  title: string;
  description: string | null;
  type: 'youtube_video' | 'podcast_episode';
  url: string;
  thumbnailUrl: string | null;
  durationSeconds: number | null;
  publishAt: string;
  createdAt: string;
}

export interface MediaContentApi {
  getMediaContent(): Promise<MediaContent[]>;
}

export function createMediaContentApi(client: ConsumerApiClient): MediaContentApi {
  return {
    getMediaContent() {
      return client.get('/media-content');
    },
  };
}
